import React, { FC } from 'react';
import './PublicationForm.css';
import {
	InputField,
	SelectField,
	TextAreaField,
	FaUser,
	FaBuilding,
	FaPodcast,
	FaCalendarAlt,
	RequiredNote,
	SelectOptionType,
	DomainFormProps,
} from '@/Shared';
import { SingleValue } from 'react-select';

/**
 * =====================================================
 * Component: PublicationForm
 * =====================================================
 *
 *
 * Domain-specific form UI for Publication.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render publication fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const PublicationForm: FC<DomainFormProps> = ({
	domainFormHook,
	formRef,
	formikProps,

}) => {

	const { setFieldValue } = formikProps;
	const { entityFormVM } = domainFormHook;

	/**
	 * =====================================================
	 * Main Form Rendering
	 * =====================================================
	 *
	 * Fieldsets organize the form into logical sections for clarity.
	 */
	return (

		<div className="fieldset-wrapper">
			<fieldset className='width-30'>
				<legend>Informations Générales</legend>
				<SelectField
					label="Bien"
					name='propertyId'
					options={entityFormVM.propertyOptions}
					required
					icon={<FaBuilding />}
					placeholder='Selectionner un bien'
					scrollParent={formRef.current}
				/>

				<SelectField
					label="Catégorie de l'annonce"
					name='adSourceCategory'
					options={entityFormVM.categoryOptions}
					required
					icon={<FaPodcast />}
					onChange={
						(selectedOption) => {
							const firstValue = entityFormVM.handleCategoryChange(
								(selectedOption as SingleValue<SelectOptionType>)?.value);

							setFieldValue('adSourceType', firstValue);
						}
					}
					scrollParent={formRef.current}
				/>

				<SelectField
					label="Type d'annonce"
					name='adSourceType'
					options={entityFormVM.typeOptions}
					required
					icon={<FaPodcast />}
					scrollParent={formRef.current}
				/>

				<InputField
					label='Date de première publication'
					name='firstPostedAt'
					type='date'
					icon={<FaCalendarAlt />}
					required
				/>

				<InputField
					label='Date de fin de publication'
					name='endPostedAt'
					type='date'
					icon={<FaCalendarAlt />}
				/>
				<RequiredNote />
			</fieldset>
			<fieldset className='width-30'>
				<legend>Auteurs & Note</legend>

				<SelectField
					label="Publié par"
					name='firstPostedBy'
					options={entityFormVM.userOptions}
					required
					icon={<FaUser />}
					placeholder='Selectionner un agent'
					scrollParent={formRef.current}
				/>
				<SelectField
					label="Retiré par"
					name='endPostedBy'
					options={entityFormVM.userOptions}
					icon={<FaUser />}
					placeholder='Selectionner un agent'
					scrollParent={formRef.current}
				/>
				<TextAreaField
					label='Note'
					name='note'
					placeholder="Ajouter une note"
				/>
				<RequiredNote />
			</fieldset>
		</div>

	);
};

export default PublicationForm;
